// extracted by mini-css-extract-plugin
export var container = "_ps-0";
export var dotAnimation = "_ps-2";
export var dotsLoading = "_ps-1";